import React from "react";
import PropTypes from "prop-types";
import { Field, FormSection } from "redux-form";
import { Select, FormInput } from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { CONDITION_TYPES } from "MODULES/Shipping/constants";
import { SCHEDULE_B_OR_HT_CODE } from "MODULES/parts/constants";
import { properCase } from "LIB/formatters/text";
import { countryOptions } from "MODULES/shared/components/CommercialInvoice/Form/FormSections/AddressFields";
import NetInvoiceWeight from "MODULES/shared/components/CommercialInvoice/Form/FormSections/NetInvoiceWeight";
import DashedSeparator from "../../../../../shared/components/DashedSeparator/DashedSeparator";
import Warning from "../../../../../shared/components/Warning/Warning";
import CurrencyField from "../../../../../shared/components/Forms/CurrencyField/CurrencyField";

const ECCNS = ["7A994", "9A991.C", "9A991.D", "9A991"];

const ECCNWarning = ({ lineItem, getField }) => {
  const eccnValue = (getField(`${lineItem}.european_commerce_control_number`) ||
    ""
  ).toUpperCase();

  if (ECCNS.concat(["", undefined, null]).includes(eccnValue)) {
    return null;
  }

  return (
    <Warning>
      Warning: Not a standard ECCN. Please confirm if license is reqd.
    </Warning>
  );
};

ECCNWarning.propTypes = {
  lineItem: PropTypes.string,
  getField: PropTypes.func.isRequired
};

export default class PartDetails extends React.Component {
  normalizeCode = value => {
    if (!value) {
      return value;
    }

    const onlyNums = value.replace(/[^\d]/g, "");
    if (onlyNums.length <= 4) {
      return onlyNums;
    }
    if (onlyNums.length <= 6) {
      return `${onlyNums.slice(0, 4)}.${onlyNums.slice(4)}`;
    }
    return `${onlyNums.slice(0, 4)}.${onlyNums.slice(4, 6)}.${onlyNums.slice(
      6,
      10
    )}`;
  };

  render() {
    const options = [
      { value: true, text: "Yes" },
      { value: false, text: "No" }
    ];
    const { fields } = this.props;
    return (
      <div>
        {fields.map(lineItem => [
          <FormRow>
            <Col md={3}>
              <Field
                name={`${lineItem}.part_number`}
                label="PN"
                component={FormInput}
                disabled
              />
            </Col>
            <Col md={2}>
              <Field
                name={`${lineItem}.description`}
                label="Desc"
                component={FormInput}
                disabled
              />
            </Col>
            <Col md={2}>
              <Field
                name={`${lineItem}.serial_number`}
                label="Serial #"
                component={FormInput}
                disabled
              />
            </Col>
            <Col md={3}>
              <Field
                name={`${lineItem}.condition`}
                component={Select}
                options={toOptions(CONDITION_TYPES)}
                label="Condition Received"
                disabled
              />
            </Col>
            <Col md={2}>
              <Field
                type="number"
                name={`${lineItem}.quantity`}
                label="Qty"
                component={FormInput}
                disabled
              />
            </Col>
          </FormRow>,
          <FormRow>
            <FormSection name={lineItem}>
              <NetInvoiceWeight lineItem={lineItem} label="Net (Part) Weight" />
            </FormSection>
            <Col md={3}>
              <Field
                name={`${lineItem}.country_of_mfg`}
                label="Country of Mfg."
                component={Select}
                options={countryOptions}
                required
              />
            </Col>
            <Col md={3}>
              <Field
                name={`${lineItem}.${SCHEDULE_B_OR_HT_CODE}`}
                label={properCase(SCHEDULE_B_OR_HT_CODE)}
                component={FormInput}
                normalize={this.normalizeCode}
                required
              />
            </Col>
          </FormRow>,
          <FormRow>
            <Col md={3}>
              <Field
                name={`${lineItem}.license_required`}
                label="Lic Reqd"
                component={Select}
                options={options}
                required
              />
            </Col>
            <Col md={3}>
              <Field
                name={`${lineItem}.european_commerce_control_number`}
                label="Eccn"
                component={FormInput}
                required
              />
            </Col>
            <Col md={3}>
              <Field
                name={`${lineItem}.price`}
                label="Price Per Unit"
                component={CurrencyField}
                disabled
              />
            </Col>
          </FormRow>,
          <ECCNWarning lineItem={lineItem} getField={this.props.getField} />,
          <DashedSeparator />
        ])}
      </div>
    );
  }
}

PartDetails.propTypes = {
  fields: PropTypes.shape({}),
  getField: PropTypes.func.isRequired,
  receivingRecord: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/FormSections/PartDetails.jsx